<style>
@media print {

  .no-print{display: none;}

}
</style>

<template>
  <div class="col-lg-9" style="padding-top: 20px; width: 75% !important">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">
          Assessment Test
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            리포트 관리 → MyPath → Assessment Report
          </div>
        </h5>
        <div id="printThis" class="mypath_wrap">
          <div
            style="
              padding: 2%;
              border: 1px solid #ccc;
              box-shadow: 1px 1px 10px #ddd;
              margin: 2%;
            "
          >
            <div
              style="
                height: 100px;
                line-height: 100px;
                font-size: 30px;
                text-align: center;
                background: #2a99ff;
                color: #fff;
                font-weight: bold;
              "
            >

              MyPath Program Assessment Test Report
            </div>
            <p
              style="
                margin-top: 20px;
                font-size: 16px;
                color: #246281;
                font-weight: 700;
              "
            >
              1.Students Information
            </p>
            <table class="table table_test" style="border-top: 1px solid #ccc">
              <tbody>
                <tr>
                  <th>Student Name</th>
                  <td><input type="text" /></td>
                </tr>
                <tr>
                  <th>Korean School Grade(한국학년)</th>
                  <td>
                    <select>
                      학년
                      <option>초등 1학년</option>
                      <option>초등 2학년</option>
                      <option>초등 3학년</option>
                      <option>초등 4학년</option>
                      <option>초등 5학년</option>
                      <option>초등 6학년</option>
                      <option>중등 1학년</option>
                      <option>중등 2학년</option>
                      <option>중등 3학년</option>
                      <option>고등 1학년</option>
                      <option>고등 2학년</option>
                      <option>고등 3학년</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>

            <p
              style="
                margin-top: 20px;
                font-size: 16px;
                color: #246281;
                font-weight: 700;
              "
            >
              2.Assessment Report
            </p>
            <table class="table table_test" style="border-top: 1px solid #ccc">
              <tbody>
                <tr>
                  <td class="td_type" style="background-color: #f8f8f8">
                    Test date
                  </td>
                  <td><input type="date" /></td>
                  <td class="td_type" style="background-color: #f8f8f8">
                    Assessed Subject
                  </td>
                  <td class="font_10">
                    <label>
                      <input type="checkbox" v-model="use_reading" />Reading
                      <input type="checkbox" v-model="use_math" />Math
                      <!-- 1개이상 이거나 둘다 일수도 있음 -->
                    </label>
                  </td>
                </tr>
                <tr>
                  <td
                    class="td_type"
                    style="background-color: #f8f8f8; padding: 15px 0px"
                  >
                    Grade Level
                  </td>
                  <td>
                    <select v-model="std_req_level">
                      <option value="0">GK</option>
                      <option value="1">GR1</option>
                      <option value="2">GR2</option>
                      <option value="3">GR3</option>
                      <option value="4">GR4</option>
                      <option value="5">GR5</option>
                      <option value="6">GR6</option>
                      <option value="7">GR7</option>
                      <option value="8">GR8</option>
                      <option value="9">GR9</option>
                      <option value="10">GR10</option>
                      <option value="11">GR11</option>
                      <option value="12">GR12</option>
                    </select>
                  </td>
                  <td class="td_type" style="background-color: #f8f8f8">
                    Assessed Grade
                  </td>
                  <td>
                    <select>
                      <option value="0">GK</option>
                      <option value="1">GR1</option>
                      <option value="2">GR2</option>
                      <option value="3">GR3</option>
                      <option value="4">GR4</option>
                      <option value="5">GR5</option>
                      <option value="6">GR6</option>
                      <option value="7">GR7</option>
                      <option value="8">GR8</option>
                      <option value="9">GR9</option>
                      <option value="10">GR10</option>
                      <option value="11">GR11</option>
                      <option value="12">GR12</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table_test">
              <tbody>
                <td colspan="3" style="border-bottom: 0px">
                  <table class="table">
                    <tr>
                      <td>
                        <GChart
                          :settings="{ packages: ['corechart', 'bar'] }"
                          type="BarChart"
                          :data="r_chartData"
                          :options="r_chartOptions"
                          class="graph"
                          style="
                            width: 300px;

                            height: 200px;
                          margin:0 auto;
                          "
                          :createChart="(el, google) => new google.charts.Bar(el)"
                        />
                      </td>
                      <td>
                        <GChart
                          :settings="{ packages: ['corechart', 'bar'] }"
                          type="BarChart"
                          :data="m_chartData"
                          :options="m_chartOptions"
                          class="graph"
                          style="width: 300px; height: 200px;margin:0 auto;"
                          :createChart="(el, google) => new google.charts.Bar(el)"
                        />
                      </td>
                    </tr>
                  </table>



                  <table class="table">
                  <!--  <tr>
                      <td style="width: 50%" v-if="use_reading"></td>
                      <td style="width: 50%" v-if="use_math"></td>
                    </tr> -->
                    <tr>
                      <td style="width: 50%" v-if="use_reading">
                        <table
                          class="table table_test"
                          style="border-top: 1px solid #ccc"
                        >
                          <tr>
                            <th class="text_center">
                              미국 {{ std_req_level }}학년 평균지수(Reading)
                            </th>
                            <td>
                              <input
                                type="text"
                                v-model.number="r_chartData[1][1]"
                              />
                            </td>
                          </tr>
                          <tr>
                            <th class="text_center">학생 평균지수(Reading)</th>
                            <td>
                              <input
                                type="text"
                                v-model.number="r_chartData[1][2]"
                              />
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td style="width: 50%" v-if="use_math">
                        <table
                          class="table table_test"
                          style="border-top: 1px solid #ccc"
                        >
                          <tr>
                            <th class="text_center">
                              미국 {{ std_req_level }}학년 평균지수(Math)
                            </th>
                            <td>
                              <input
                                type="text"
                                v-model.number="m_chartData[1][1]"
                              />
                            </td>
                          </tr>
                          <tr>
                            <th class="text_center">학생 평균지수(Math)</th>
                            <td>
                              <input
                                type="text"
                                v-model.number="m_chartData[1][2]"
                              />
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tbody>
            </table>

            <p
              style="
                margin-top: 10px;
                font-size: 16px;
                color: #246281;
                font-weight: 700;
              "
            >
              3.Evaulation
            </p>
            <table class="table table_test">
              <tbody>
                <tr style="border-top: 1px solid #ccc;">
                  <th class="th_center" style="height:34px;">Reading</th>
                  <th class="th_center" style="height:34px;">Math</th>
                </tr>
                <tr>
                  <td
                    style="text-align: center; "  class="font_10"
                  >
                    <input type="checkbox" />높음 <input type="checkbox" />적합
                    <input type="checkbox" />낮음
                  </td>
                  <td style="text-align: center" class="font_10">
                    <input type="checkbox" />높음 <input type="checkbox" />적합
                    <input type="checkbox" />낮음
                  </td>
                </tr>
              </tbody>
            </table>
            <p
              style="
                margin-top: 10px;
                margin-bottom: 0;
                font-size: 16px;
                color: #246281;
                font-weight: 700;
              "
            >
              4. Teacher's Comment
            </p>
            <table class="table table_test">
              <tbody>
                <tr>
                  <td>
                    <textarea
                      style="
                        width: 96%;
                        padding: 2px 10px;
                        border: 1px solid #ccc;
                        border-radius: 10px;
                        height:120px;
                      "
                    >학생에게 남길말을 적어주세요.(최대6줄)
                    </textarea>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="text-align: center;" class="no-print">
              <button @click="printIt()" class="btn btn-danger">
                리포트 출력
              </button>
            </div>
          </div>
        </div>
        <!-- print this -->
      </div>
    </div>
  </div>
</template>
<script>
import printJS from "print-js";

import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart,
  },
  methods: {
    printIt() {
      printJS({
        printable: "printThis",
        type: "html",
        css: ["./print_report.css"],
        scanStyles: false,
      });
    },
  },
  data() {
    return {
      use_math: true,
      use_reading: true,
      std_req_level: 0,
      // Array will be automatically processed with visualization.arrayToDataTable function
      r_chartData: [
        ["", "Grade Average", "Student"],

        ["Reading", 100, 100],
      ],
      r_chartOptions: {
        chart: {
          title: "Reading",
        },
      },
      m_chartData: [
        ["", "Grade Average", "Student"],

        ["Math", 100, 100],
      ],
      m_chartOptions: {
        chart: {
          title: "Math",
        },
      },
    };
  },
};
</script>
